<ul class="layout-menu">
  <li *ngFor="let item of model; let i = index;">
    <app-menu-item [item]="item" [index]="i" [root]="true"></app-menu-item>
  </li>
</ul>
